import React from 'react'
import classNames from 'classnames'

import { useFormatMessage } from '../../intl/intl'
import StoresFilterButton from '../stores-filter-button'
import OrderSearchTextField from '../order-search-text-field'

import { textIds } from './const'
import useStyles from './OrdersKanbanAdvancedFiltersToolbar.styles'

const OrdersKanbanAdvancedFiltersToolbar = ({ showStoresFilterButton }) => {
  const componentClasses = useStyles()
  const advancedFiltersText = useFormatMessage(textIds.advancedFiltersText)

  return (
    <div className={componentClasses.root}>
      <p className={componentClasses.advancedFiltersText}>
        {advancedFiltersText}
      </p>

      <OrderSearchTextField
        fullWidth={true}
        classes={{
          root: classNames(componentClasses.orderSearchTextFieldRoot),
          input: classNames(componentClasses.input),
        }}
      />

      {showStoresFilterButton && <StoresFilterButton />}
    </div>
  )
}

export default OrdersKanbanAdvancedFiltersToolbar
